import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "./features/profile/profileSlice";
import userReducer from "./features/users/userSlice";
import generalReducer from "./features/generalSlice";
import contactsReducer from "./features/contactsSlice";
import sharesReducer from "./features/sharesSlice";

export const makeStore = () => {
  return configureStore({
    reducer: {
      profile: profileReducer,
      users: userReducer,
      general: generalReducer,
      contacts: contactsReducer,
      shares: sharesReducer,
    },
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
